export default __webpack_public_path__ + "394af8188dfaff27e3120c7fe21bc817.webp";